import { useTheme } from '@mui/material/styles';

import { useMatchQuery } from './useMatchQuery';

/**
 * Пользовательский хук, который определяет, является ли текущий размер экрана таблетом или большим.
 *
 * @returns - Возвращает true, если размер экрана 'sm' или больше, иначе false.
 */

export const useIsNotepad = () => {
  const theme = useTheme();

  return useMatchQuery(theme.breakpoints.down('lg'));
};
